export default class AreaLayer {
  constructor(stage, width, height, cropRect) {
    this.cropRect = cropRect;
    this.stage = stage;
    this.layer = new Konva.Layer({
      x: -width * 0.5,
      y: -height * 0.5,
      listening: false
    });
    // this.overlay = new Konva.shapes

    const focus = { width: 100, height: 100 };

    // this.rect1 = new Konva.Rect({
    //   x: -focus.width * 0.5,
    //   y: -focus.height * 0.5,
    //   width: focus.width,
    //   height: focus.height,
    //   fill: "rgba(0, 0, 0, 0.5)"
    // });
    // this.layer.add(this.rect1);

    // this.createOverlayShapes(stage, focus);
  }

  fitArea(img) {

    const color = "rgba(0, 0, 0, 0.5)";
    const imgW = img.width();
    const imgH = img.height();
    const w1 = (imgW - this.cropRect.width) * 0.5;
    const h1 = (imgH - this.cropRect.height) * 0.5;
    let baseX = img.x();
    let baseY = img.y();
    const rectTop = new Konva.Rect({
      x: baseX,
      y: baseY,
      width: imgW,
      height: h1,
      fill: color
    });
    this.layer.add(rectTop);
    const rectBottom = new Konva.Rect({
      x: baseX,
      y: baseY + imgH - h1,
      width: imgW,
      height: h1,
      fill: color
    });
    this.layer.add(rectBottom);
    const rectLeft = new Konva.Rect({
      x: baseX,
      y: baseY + h1,
      width: (imgW - this.cropRect.width) * 0.5,
      height: this.cropRect.height,
      fill: color
    });
    this.layer.add(rectLeft);
    const rectRight = new Konva.Rect({
      x: baseX + (imgW + this.cropRect.width) * 0.5,
      y: baseY + h1,
      width: (imgW - this.cropRect.width) * 0.5,
      height: this.cropRect.height,
      fill: color
    });
    this.layer.add(rectRight);

    const marginRect = { height: 5000 };

    const rectTop2 = new Konva.Rect({
      x: baseX,
      y: baseY - marginRect.height,
      width: imgW,
      height: marginRect.height,
      fill: color
    });
    this.layer.add(rectTop2);
    const rectTop3 = new Konva.Rect({
      x: baseX,
      y: baseY + imgH,
      width: imgW,
      height: marginRect.height,
      fill: color
    });
    this.layer.add(rectTop3);
  }

  enable() {
    this.stage.add(this.layer);
  }
  disable() {
    this.layer.remove();
  }

  createOverlayShapes(stage, focus) {
    let scale = stage.scaleX();
    const sw = stage.width() / scale;
    const sh = stage.height() / scale;

    const w1 = (sw - focus.width) * 0.5;
    const h1 = (sh - focus.width) * 0.5;

    const color = "rgba(0, 0, 0, 0.5)";
    const x = -3840 * 0.5;
    const y = 0;
    const rect1 = new Konva.Rect({
      x: x,
      y: y,
      width: 3840,
      height: 1080,
      fill: color
    });
    this.layer.add(rect1);
  }
}
